import React, { Component } from 'react'
// import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
// import { AxiosUsersService } from "../../services/net/AxiosUsersService"
// import { UsersService } from "../../services/local/UsersService";
import 'whatwg-fetch'
import firebase from 'firebase'
// import { Redirect } from 'react-router-dom'
// import {NotificationService} from '../../services/local/NotificationService'

import {
    Grid,
    Form,
    Segment,
    Button,
    Header,
    Message,
    Image,
    Icon
} from "semantic-ui-react";


import toaster from "toasted-notes";
import "toasted-notes/src/styles.css"; // optional styles

 

import { Redirect, withRouter, Link } from 'react-router-dom'
import { MyStore } from '../../../../services/Store'
import { Consumer } from '../../../../context/Context';
import axios from 'axios';
import md5 from "md5";

// const image2base64 = require('image-to-base64');


 



class CreateAccount extends Component {
    constructor(props) {
        super(props);
        this.options = ''


    }
    // state = {
    //     email: localStorage.getItem('emailForSignIn'),
    //     // email: localStorage.getItem('emailForSignIn') ? localStorage.getItem('emailForSignIn') : '',
    //     password: '',
    //     displayName: '',
    //     photoURL: '',
    //     errors: {},
    //     isSignUp: true,
    //     options: '',
    //     username:'',
    //     loading:'',

    //     usersRef: MyStore.database().ref("users"),
    //     usernamesRef: MyStore.database().ref("usernames"),
    //     groupsRef: MyStore.database().ref("groups"), 
    //     userGroups:MyStore.database().ref("groups"),
    // };

    state = {
        displayName:'',
        username: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        errors: [],
        loading: false,

        cavatar:'',
        role:'',
        fullname:'',
        oname:'',
        address:'',
        city:'',
        postal:'',

        options:'',
        usersRef: MyStore.database().ref("members"),
        usernamesRef: MyStore.database().ref("consumers"),
        groupsRef: MyStore.database().ref("cadre")
    };


    isEmptyForm = ({ username, email, password, passwordConfirmation }) => {
        return (
            !username.length ||
            !email.length ||
            !password.length ||
            !passwordConfirmation.length
        );
    };

    isValidPassword = ({ password, passwordConfirmation }) => {
        if (password.length < 6) {
            return false;
        } else if (password !== passwordConfirmation) {
            return false;
        } else {
            return true;
        }
    };

    isValidUsername = ({ username }) => {
        return username.length <= 12;
    };

    isTakenUsername = async ({ username, usernamesRef }) => {
        const snap = await usernamesRef.child(username).once("value");
        return new Promise(resolve => {
            resolve(snap.exists());
        });
    };

    isValidForm = () => {
        let errors = [];
        let error;

        if (this.isEmptyForm(this.state)) {
            error = { message: "Fill in all fields" };
            this.setState({ errors: errors.concat(error.message) });
            return false;
        } else if (!this.isValidPassword(this.state)) {
            error = {
                message: "Passwords must be 6+ characters long and matching"
            };
            this.setState({ errors: errors.concat(error.message) });
            return false;
        } else if (!this.isValidUsername(this.state)) {
            error = {
                message: "Username must be 12 characters or less"
            };
            this.setState({ errors: errors.concat(error.message) });
        } else {
            return true;
        }
    };

    handleInputErrors = (errors, inputType) =>
        errors.some(e => e.toLowerCase().includes(inputType)) ? "error" : "";

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async e => {
        e.preventDefault();

        if (this.isValidForm()) {
            this.setState({ errors: [], loading: true });

            const { username, email, password, usernamesRef } = this.state;
            let errors = [];

            const taken = await this.isTakenUsername(this.state);

            if (taken) {
                let error = { message: "Username taken" };
                this.setState({
                    loading: false,
                    errors: errors.concat(error.message)
                });
                return;
            }

            MyStore
                .auth()
                .createUserWithEmailAndPassword(email, password)
                .then(resp => {
                    const { user } = resp;

                    user.updateProfile({
                        displayName: username,
                        photoURL: `http://gravatar.com/avatar/${md5(
                            user.email
                        )}?d=identicon`
                    })
                        .then(() => {
                            this.saveUser(user).then(() => {
                                usernamesRef
                                    .child(username)
                                    .set({
                                        username: username,
                                        uid: user.uid,
                                        avatar: user.photoURL
                                    })
                                //     .then(this.createFirstGroup(user));
                                // console.log(user);
                                // .then(this.createFirstGroup(user));

                                .then(()=>{

                                if(this.state.options === 'admin'){
                                    console.log('------------ this.state.option --------- line 194')
                                    console.log(this.state.options)
                                    this.createFirstGroup(user)
                                }
                                else{
                                    console.log('--------- line 203 --------')
                                    console.log(' coordinator or clinician')

                                }

           
                                })

                            

                                
                            });
                        })
                        .catch(err => {
                            this.setState({
                                loading: false,
                                errors: errors.concat(err.message)
                            });
                        });
                })
                .catch(err => {
                    this.setState({
                        loading: false,
                        errors: errors.concat(err.message)
                    });
                });
        }
    };




    
    addFirstGroupToUser = (snap, uid, groupId) => {
        const { usersRef, oname, cavatar, address, city , postal  } = this.state;
        let userGroups = snap.child("cadre").val();

        if (!userGroups) {
            userGroups = {};
        }

        userGroups[groupId] = {
            cid: groupId,
            oname: oname,
            avatar: cavatar, 
            address: address,
            city: city, 
            postal: postal,

            
            
            details: {
                address: address,
                city: city,
                postal: postal,
                // oname: oname,
            },
            isMember: true
        };

        usersRef.child(uid).update({
            cid: groupId,
            cadre: userGroups
        });
    };


    
    createFirstGroup = user => {
        const { groupsRef, usersRef, oname, options, fullname, address, city, postal} = this.state;

        const groupId = groupsRef.push().key;

        this.setState({cavatar: `http://gravatar.com/avatar/${md5(oname)}?d=identicon`})


        const newGroup = {
            cid: groupId,
            oname: `${oname}`,
            avatar:  `http://gravatar.com/avatar/${md5(
                        oname
                )}?d=identicon`,
            details: {
                address: address,
                city: city,
                postal: postal,
                // oname: oname,
            },
            createdBy: {
                username: user.displayName,
                avatar: user.photoURL,
                uid: user.uid,
                role: options,
                fullname:fullname,
            },
            dateCreated: new Date(),
            members: {
                [user.uid]: {
                    username: user.displayName, 
                    avatar: user.photoURL,
                    uid: user.uid,
                    role: options,
                    fullname:fullname,
                }
            }
        };
        groupsRef
            .child(groupId)
            .update(newGroup)
            .then(() => {
                usersRef.child(user.uid).once("value", snap => {
                    this.addFirstGroupToUser(snap, user.uid, groupId);
                });
            })
            .catch(error => {
                console.error(error);
            });
    };


    saveUser = user => {
        return this.state.usersRef.child(user.uid).set({
            username: user.displayName,
            avatar: user.photoURL
        });
    };

    componentDidMount(){
        const {usernamesRef} = this.state
        console.log('------------- line 212')
        console.log()
        console.log(this.state.groupsRef)
        // console.log(usernamesRef)
        console.log(this.state.usernamesRef)
        usernamesRef.child('3YyIUxDEx1f4hqxnFX4SqmpbTJw2')
        console.log()
 
            // this.saveUser(user).then(() => {
            //     usernamesRef
            //         .child(username)
            //         .set({
            //             username: username,
            //             uid: user.uid,
            //             avatar: user.photoURL
            //         })
            //         .then(this.createFirstGroup(user));
                    
            //     console.log(user);
            // });

    }

    componentDidUpdate(){
        console.log('--------- line 295 comp did up ----------')
        console.log(this.state.options)
    }


    handleMenuChange = value => {
        //  alert(value)
        this.options = value
        this.setState({
            options: value
        })
        // console.log(serviceOptions[0].text)
    }



    DropdownExampleSelection = (onChange, value) => (
        <React.Fragment >
            {/* {this.setState({role:value})} */}
            {this.state.role = value}
        <Form.Select
              style={{marginBottom: '50px'}}
            fluid
            // label='Role in your Organization'
            options={options}
            placeholder='Role'

            onChange={(e, { value }) => {
                console.log('--------- line 116 ------- ')
                console.log(value)
                this.handleMenuChange(value)
            }
            }
        />

        </React.Fragment>

    )

        

    // onChange = e => this.setState({ [e.target.name]: e.target.value });

    render() {
        const {
            username,
            email,
            password,
            passwordConfirmation,
            loading,
            errors,



            
            fullname,
            oname,
            address, 
            city,
            postal, 
    

        } = this.state;

        return (
            <Grid textAlign="center"   className="app" style={{ height: '80vh' }}>
                <Grid.Column style={{ maxWidth: 450 }}>
                    {/* <Header
                        as="h1"
                        icon
                        textAlign="center"
                        style={{
                            textShadow: ".075em .075em black",
                            fontSize: "3rem",
                            // color: "lightcyan",
                            marginTop: "2.32rem",
                            marginBottom: "0"
                        }}
                    >
                        <Icon name="gg" style={{ color: "black" }} />
                        Register
                    </Header> */}

                    <Header as='h2' color='teal' 
                     as="h1"
                        icon
                        textAlign="center"
                        style={{
                            // textShadow: ".075em .075em black",
                            // fontSize: "3rem",
                            // color: "lightcyan",
                            marginTop: "2.32rem",
                            marginBottom: "0"
                        }}>
                        <Image src='https://react.semantic-ui.com/logo.png' /> Create a new account
                </Header>

                <div className="login container pt-5">
                    <Form size="large" onSubmit={this.handleSubmit}>
                        <Segment
                            stacked
                            id="register__segment"
                            style={{
                                background: "transparent",
                                border: "1px solid transparent",
                                boxShadow: "none"
                            }}
                        >


                                    {this.DropdownExampleSelection()}



                                    <Form.Input
                                // label='Email is your Login Handle'
                                fluid
                                id="register__email__input"
                                className={this.handleInputErrors(
                                    errors,
                                    "fullname"
                                )}
                                name="fullname"
                                icon='user circle outline'
                                iconPosition="left"
                                placeholder="Full name"
                                type="text"
                                onChange={this.handleChange}
                                value={fullname}
                            />


                            <label style={{ float: "center" }}><b> Email is your Login Handle  </b></label>
                            
                            <Form.Input
                                // label='Email is your Login Handle'
                                fluid
                                id="register__email__input"
                                className={this.handleInputErrors(
                                    errors,
                                    "email"
                                )}
                                name="email"
                                icon="at"
                                iconPosition="left"
                                placeholder="Email"
                                type="email"
                                onChange={this.handleChange}
                                value={email}
                            />



                            
                 

                            <Form.Input
                                fluid
                                id="register__username__input"
                                className={this.handleInputErrors(
                                    errors,
                                    "username"
                                )}
                                name="username"
                                icon="user"
                                iconPosition="left"
                                placeholder="Username"
                                type="text"
                                onChange={this.handleChange}
                                value={username}
                            />

                            <Form.Input
                                fluid
                                id="register__pw__input"
                                className={this.handleInputErrors(
                                    errors,
                                    "password"
                                )}
                                name="password"
                                icon="lock"
                                iconPosition="left"
                                placeholder="Password"
                                type="password"
                                onChange={this.handleChange}
                                value={password}
                            />

                            <Form.Input
                                fluid
                                id="register__pwconf__input"
                                className={this.handleInputErrors(
                                    errors,
                                    "password"
                                )}
                                name="passwordConfirmation"
                                icon="repeat"
                                iconPosition="left"
                                placeholder="Confirm Password"
                                type="password"
                                onChange={this.handleChange}
                                value={passwordConfirmation}
                            />


                            {this.state.options === options[0].value ? (
                                        <React.Fragment>
                                            <label style={{ float: "left" }} ><b> Name of the organization </b></label>
                                            <Form.Input 
                                            icon='building outline' iconPosition="left"
                                            fluid placeholder='Name of the organization' name='oname' value={oname}   onChange={this.handleChange} />


                                            <label style={{ float: "left" }} ><b> Address of your organization </b></label>
                                            <Form.Input fluid placeholder='Address of the organization' 
                                            icon='envelope outline' iconPosition='left'
                                            name='address' value={address}   onChange={this.handleChange}/>

                                            <Form.Group widths='equal'>
                                                <label > <b>City </b>  </label>
                                                <Form.Input fluid placeholder='City' labelPosition='left'name='city' value={city}   onChange={this.handleChange} 
                                                    icon='envelope outline' iconPosition='left'
                                                />
                                                <label ><b>Postal Code</b></label>
                                                <Form.Input fluid placeholder='Postal Code' labelPosition='left'name='postal' value={postal}   onChange={this.handleChange}
                                                icon='envelope outline' iconPosition='left'
                                                />

                                                {/* </Segment> */}
                                            </Form.Group>

                                        </React.Fragment>
                                    ) : (
                                            <React.Fragment  >




                                            </React.Fragment>
                                        )}


                            <Button
                                id="register__button"
                                disabled={loading}
                                className={loading ? "loading" : ""}
                                color="blue"
                                fluid
                                size="large"
                                style={{ opacity: "0.75" }}
                            >
                                Register
                            </Button>
                        </Segment>
                    </Form>
       

                    <Message>
                                 Already a user?{" "}
                                    <Link to="/login"> Sign Up </Link>
                                    </Message>
                    <Segment
                        style={{
                            minHeight: "3rem",
                            background: "transparent",
                            border: "1px solid transparent",
                            boxShadow: "none",
                            // marginTop: "0",
                            // marginBottom: "0",
                            // padding: "0"
                        }}
                    >
                        {errors.length > 0 && (
                            <Message
                                error
                                size="tiny"
                                list={errors}
                                id="error__message"
                            />
                        )}
                    </Segment>
                </div>
                   
                </Grid.Column>
            </Grid>
        );
    }
}



const options = [
    { key: 'admin', text: 'Organization Administrator', value: 'admin' },
    { key: 'c', text: 'Clinician', value: 'clinician' },
    { key: 'co', text: 'Coordinator', value: 'coord' },
]






export default CreateAccount;
